import { DEFAULT_DESIGN_CONFIG } from '../config/assets';

/**
 * Genera estilos CSS variables e inline desde la configuración
 * Usa DEFAULT_DESIGN_CONFIG cuando faltan valores
 */
export function getConfigStyles(config) {
  const c = config || DEFAULT_DESIGN_CONFIG;

  const vars = {};
  if (c.fontColor) vars['--config-font-color'] = c.fontColor;
  if (c.fontColorSecondary) vars['--config-font-color-secondary'] = c.fontColorSecondary;
  if (c.fontFamily) vars['--config-font-family'] = c.fontFamily;
  if (c.primaryColor) vars['--config-primary'] = c.primaryColor;
  if (c.secondaryColor) vars['--config-secondary'] = c.secondaryColor;
  if (c.buttonColor) vars['--config-button-bg'] = c.buttonColor;
  if (c.buttonTextColor) vars['--config-button-text'] = c.buttonTextColor;
  if (c.bodyBackground) vars['--config-body-bg'] = c.bodyBackground;

  return {
    style: Object.keys(vars).length ? vars : undefined,
    bodyBackground: c.bodyBackground,
    bodyBackgroundImage: c.bodyBackgroundImage || DEFAULT_DESIGN_CONFIG.bodyBackgroundImage,
    headerText: c.headerText,
    headerImage: c.headerImage || DEFAULT_DESIGN_CONFIG.headerImage,
    headerVideo: c.headerVideo,
    logoUrl: c.logoUrl || DEFAULT_DESIGN_CONFIG.logoUrl,
    buttonText: c.buttonText,
    resourcesLink: c.resourcesLink,
    tabTitle: c.tabTitle,
    tabDescription: c.tabDescription,
    additionalLogos: Array.isArray(c.additionalLogos) ? c.additionalLogos : (DEFAULT_DESIGN_CONFIG.additionalLogos || []),
    mujerKvUrl: c.mujerKvUrl || DEFAULT_DESIGN_CONFIG.mujerKvUrl,
    welcomeLogos: c.welcomeLogos || DEFAULT_DESIGN_CONFIG.welcomeLogos,
  };
}
